import script from "./RunningGameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RunningGameCard.vue?vue&type=script&setup=true&lang=js"

import "./RunningGameCard.vue?vue&type=style&index=0&id=7b99e47a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b99e47a"]])

export default __exports__